/* eslint-disable */
import React, { useState } from 'react';
import {
  Form, Input, Select, Row, Col, Radio, Spin, message, Modal,
} from 'antd';
import { CaretDownFilled } from '@ant-design/icons';
import JSONInput from 'react-json-editor-ajrm';
import locale from 'react-json-editor-ajrm/locale/en';
import { FormLayoutType } from '../../types/otherTools';
import { publishAPI } from '../../api/index';
import styles from './Form.module.scss';
import ScanView from '../ScanView';
import Urls from '../../enum/urls';

const FormLay: React.FC = () => {
  const [form] = Form.useForm();
  const [responseExample, setResponseExample] = useState({});
  const [bodyParams, setBodyParams] = useState({});
  const [hasBody, setHasBody] = useState<String>('');
  const [showChooseBody, setShowChooseBody] = useState<String>('');
  const [loading, setLoading] = useState(false);

  const [isScanShowing, setIsScanShowing] = useState<boolean>(false);
  const [scanParams, setScanParams] = useState<any>(null);
  const cancelScan = () => {
    setIsScanShowing(false);
  };
  const onReset = () => {
    form.resetFields();
  };
  const scanSuccessHandler = () => {
    setIsScanShowing(false);
    onReset();
    message.success('Publish success!');
  };
  const scanFailHandler = () => {
    setIsScanShowing(false);
    message.error('Publish fail. Try again!');
  };

  const editResponse = (values: any) => {
    setResponseExample(values.json);
  };
  const editBodyParams = (values: any) => {
    setBodyParams(values.json);
  };
  const onFinish = (values: any) => {
    console.log('Received values of form:', values);
  };
  const onChange = (e: any) => {
    setHasBody(e.target.value);
  };
  const handleChange = (value: any) => {
    console.log(`selected ${value}`);
    setShowChooseBody(value);
  };
  const HandlerPublish = () => {
    form.validateFields().then(async (values) => {
      console.log(values);
      setScanParams(values);
      setIsScanShowing(true);
    }).catch((info) => {
      console.log('validate failed', info);
    });
  };
  return (
    <div className={`${styles.fromLay} g-card`}>
      <Spin spinning={loading}>
        <Form
          form={form}
          layout={FormLayoutType.Vertical}
          name="dynamic_form_nest_item"
          onFinish={onFinish}
          autoComplete="off"
          id="subForm"
          style={{
            minHeight: '620px',
          }}
        >
          {/* title */}
          <Form.Item
            label="Title"
            name="name"
            rules={[{ required: true, message: 'Please input your title!' }]}
          >
            <Input placeholder="title" />
          </Form.Item>

          {/* abstract */}
          <Form.Item
            label="Abstract"
            name="abstract"
            rules={[{ required: true, message: 'Please input your abstract!' }]}
          >
            <Input.TextArea autoSize={{ minRows: 3, maxRows: 6 }} placeholder="abstract" />
          </Form.Item>

          {/* description */}
          <Form.Item
            label="Description"
            name="description"
            rules={[{ required: true, message: 'Please input your description!' }]}
          >
            <Input.TextArea autoSize={{ minRows: 6, maxRows: 6 }} placeholder="description" />
          </Form.Item>

          {/* API URL */}
          <Form.Item
            label="API URL"
            name="apiProvider"
            rules={[{ required: true, message: 'Please input your API URL!' }, {
              pattern: /^((ht|f)tps?):\/\/[\w\-]+(\.[\w\-]+)+([\w\-.,@?^=%&:\/~+#]*[\w\-@?^=%&\/~+#])?$/,
              message: 'Please enter the correct API URL!',
            }]}
          >
            <Input placeholder="API URL" />
          </Form.Item>
          {/* <Row> */}
          {/*  <Col span={12}> */}
          {/*    <Form.Item */}
          {/*      label="Request Method" */}
          {/*      name="requestType" */}
          {/*      rules={[{ required: true, message: "Miss Request Method" }]} */}
          {/*    > */}
          {/*      <Select */}
          {/*        dropdownClassName="primarySelectCss" */}
          {/*        placeholder="Select Request Method" */}
          {/*        suffixIcon={<CaretDownFilled />} */}
          {/*        onChange={handleChange} */}
          {/*      > */}
          {/*        <Select.Option value="GET">GET</Select.Option> */}
          {/*        <Select.Option value="POST">POST</Select.Option> */}
          {/*      </Select> */}
          {/*    </Form.Item> */}
          {/*  </Col> */}
          {/* </Row> */}
          {/* if post body */}
          {/* {showChooseBody === 'POST' && <Form.Item */}
          {/*  label="Whether it contains other body parameters" */}
          {/*  name="isHasBody" */}
          {/* > */}
          {/*  <Radio.Group onChange={e => { */}
          {/*    onChange(e) */}
          {/*  }} value={hasBody}> */}
          {/*    <Radio value={'hasBody'}>True</Radio> */}
          {/*    <Radio value={'noBody'}>False</Radio> */}
          {/*  </Radio.Group> */}
          {/* </Form.Item>} */}
          {/* { */}
          {/*  hasBody === 'hasBody' && <div style={{ */}
          {/*    marginBottom: '30px' */}
          {/*  }}> */}
          {/*    <JSONInput */}
          {/*      id="a_unique_id2" */}
          {/*      placeholder={{}} */}
          {/*      locale={locale} */}
          {/*      height="350px" */}
          {/*      width="100%" */}
          {/*      onChange={(value: any) => { */}
          {/*        editBodyParams(value) */}
          {/*      }} */}
          {/*    /> */}
          {/*  </div> */}
          {/* } */}

          {/* <div> */}
          {/*  <div className={"cusPrimaryLabelCss"}>Encryption parameters</div> */}
          {/*  <div> */}
          {/*    <Form.List name="cryptoInfos"> */}
          {/*      {(fields, { add, remove }) => { */}
          {/*        return ( */}
          {/*          <div> */}
          {/*            {fields.map((field) => ( */}
          {/*              <Row gutter={16} key={field.key}> */}
          {/*                <Col className="gutter-row" span={6}> */}
          {/*                  <Form.Item */}
          {/*                    {...field} */}
          {/*                    name={[field.name, "cryptoKey"]} */}
          {/*                    fieldKey={[field.fieldKey, "cryptoKey"]} */}
          {/*                    rules={[{ required: true, message: "Miss CryptoKey" }]} */}
          {/*                  > */}
          {/*                    <Input placeholder="Enter CryptoKey" /> */}
          {/*                  </Form.Item> */}
          {/*                </Col> */}
          {/*                <Col className="gutter-row" span={6}> */}
          {/*                  <Form.Item */}
          {/*                    {...field} */}
          {/*                    name={[field.name, "cryptoWhere"]} */}
          {/*                    fieldKey={[field.fieldKey, "cryptoWhere"]} */}
          {/*                    rules={[ */}
          {/*                      { */}
          {/*                        required: true, */}
          {/*                        message: "Miss Encryption Location", */}
          {/*                      }, */}
          {/*                    ]} */}
          {/*                  > */}
          {/*                    <Select */}
          {/*                      dropdownClassName="primarySelectCss" */}
          {/*                      placeholder="Select Encryption Location" */}
          {/*                      suffixIcon={<CaretDownFilled />} */}
          {/*                    > */}
          {/*                      <Select.Option value={1}>Body</Select.Option> */}
          {/*                      <Select.Option value={2}>Header</Select.Option> */}
          {/*                    </Select> */}
          {/*                  </Form.Item> */}
          {/*                </Col> */}
          {/*                <Col className="gutter-row" span={5}> */}
          {/*                  <Form.Item */}
          {/*                    {...field} */}
          {/*                    name={[field.name, "cryptoType"]} */}
          {/*                    fieldKey={[field.fieldKey, "cryptoType"]} */}
          {/*                    rules={[ */}
          {/*                      { */}
          {/*                        required: true, */}
          {/*                        message: "Miss Encryption Location", */}
          {/*                      }, */}
          {/*                    ]} */}
          {/*                  > */}
          {/*                    <Select */}
          {/*                      dropdownClassName="primarySelectCss" */}
          {/*                      placeholder="Select Encryption Location" */}
          {/*                      suffixIcon={<CaretDownFilled />} */}
          {/*                    > */}
          {/*                      <Select.Option value={1}>MD5</Select.Option> */}
          {/*                    </Select> */}
          {/*                  </Form.Item> */}
          {/*                </Col> */}
          {/*                <Col className="gutter-row" span={6}> */}
          {/*                  <Form.Item */}
          {/*                    {...field} */}
          {/*                    name={[field.name, "cryptoValue"]} */}
          {/*                    fieldKey={[field.fieldKey, "cryptoValue"]} */}
          {/*                    rules={[ */}
          {/*                      { */}
          {/*                        required: true, */}
          {/*                        message: "Missing Encryption Value", */}
          {/*                      }, */}
          {/*                    ]} */}
          {/*                  > */}
          {/*                    <Input placeholder="Enter Encryption Value" /> */}
          {/*                  </Form.Item> */}
          {/*                </Col> */}
          {/*                <Col className={"gutter-row " + styles.selectIconCss} span={1}> */}
          {/*                  <i */}
          {/*                    onClick={() => { */}
          {/*                      remove(field.name); */}
          {/*                    }} */}
          {/*                    className={"iconfont iconClose"} */}
          {/*                  /> */}
          {/*                </Col> */}
          {/*              </Row> */}
          {/*            ))} */}
          {/*            {fields.length < 3 && ( */}
          {/*              <Form.Item> */}
          {/*                <div */}
          {/*                  className={styles.add_btn_} */}
          {/*                  onClick={() => { */}
          {/*                    add(); */}
          {/*                  }} */}
          {/*                > */}
          {/*                  + Add */}
          {/*                </div> */}
          {/*              </Form.Item> */}
          {/*            )} */}
          {/*          </div> */}
          {/*        ); */}
          {/*      }} */}
          {/*    </Form.List> */}
          {/*  </div> */}
          {/* </div> */}

          {/* <div> */}
          {/*  <div className={"cusPrimaryLabelCss"}>Request parameter description</div> */}
          {/*  <div> */}
          {/*    <Form.List name="params"> */}
          {/*      {(fields, { add, remove }) => { */}
          {/*        return ( */}
          {/*          <div> */}
          {/*            {fields.map((field) => ( */}
          {/*              <Row gutter={16} key={field.key}> */}
          {/*                <Col className="gutter-row" span={4}> */}
          {/*                  <Form.Item */}
          {/*                    {...field} */}
          {/*                    name={[field.name, "paramName"]} */}
          {/*                    fieldKey={[field.fieldKey, "paramName"]} */}
          {/*                    rules={[{ required: true, message: "Miss paramName" }]} */}
          {/*                  > */}
          {/*                    <Input placeholder="Enter paramName" /> */}
          {/*                  </Form.Item> */}
          {/*                </Col> */}
          {/*                <Col className="gutter-row" span={4}> */}
          {/*                  <Form.Item */}
          {/*                    {...field} */}
          {/*                    name={[field.name, "required"]} */}
          {/*                    fieldKey={[field.fieldKey, "required"]} */}
          {/*                    rules={[ */}
          {/*                      { */}
          {/*                        required: true, */}
          {/*                        message: "Miss required", */}
          {/*                      }, */}
          {/*                    ]} */}
          {/*                  > */}
          {/*                    <Select placeholder="Select Required" suffixIcon={<CaretDownFilled />}> */}
          {/*                      <Select.Option value={1}>True</Select.Option> */}
          {/*                      <Select.Option value={0}>False</Select.Option> */}
          {/*                    </Select> */}
          {/*                  </Form.Item> */}
          {/*                </Col> */}
          {/*                <Col className="gutter-row" span={5}> */}
          {/*                  <Form.Item */}
          {/*                    {...field} */}
          {/*                    name={[field.name, "paramWhere"]} */}
          {/*                    fieldKey={[field.fieldKey, "paramWhere"]} */}
          {/*                    rules={[ */}
          {/*                      { */}
          {/*                        required: true, */}
          {/*                        message: "Miss Type", */}
          {/*                      }, */}
          {/*                    ]} */}
          {/*                  > */}
          {/*                    <Select */}
          {/*                      suffixIcon={<CaretDownFilled />} */}
          {/*                      dropdownClassName="primarySelectCss" */}
          {/*                      placeholder="Select Type" */}
          {/*                    > */}
          {/*                      <Select.Option value={1}>Path parameter</Select.Option> */}
          {/*                      <Select.Option value={2}>Query parameter</Select.Option> */}
          {/*                      <Select.Option value={3}>Post body parameter</Select.Option> */}
          {/*                      <Select.Option value={4}>Header parameter description</Select.Option> */}
          {/*                    </Select> */}
          {/*                  </Form.Item> */}
          {/*                </Col> */}
          {/*                <Col className="gutter-row" span={4}> */}
          {/*                  <Form.Item */}
          {/*                    {...field} */}
          {/*                    name={[field.name, "paramTag"]} */}
          {/*                    fieldKey={[field.fieldKey, "paramTag"]} */}
          {/*                    rules={[ */}
          {/*                      { */}
          {/*                        required: true, */}
          {/*                        message: "Miss fixed", */}
          {/*                      }, */}
          {/*                    ]} */}
          {/*                  > */}
          {/*                    <Select */}
          {/*                      suffixIcon={<CaretDownFilled />} */}
          {/*                      dropdownClassName="primarySelectCss" */}
          {/*                      placeholder="Select fixed" */}
          {/*                    > */}
          {/*                      <Select.Option value={1}>True</Select.Option> */}
          {/*                      <Select.Option value={0}>False</Select.Option> */}
          {/*                    </Select> */}
          {/*                  </Form.Item> */}
          {/*                </Col> */}
          {/*                <Col className="gutter-row" span={6}> */}
          {/*                  <Form.Item */}
          {/*                    {...field} */}
          {/*                    name={[field.name, "note"]} */}
          {/*                    fieldKey={[field.fieldKey, "note"]} */}
          {/*                    rules={[ */}
          {/*                      { */}
          {/*                        required: true, */}
          {/*                        message: "Missing Example", */}
          {/*                      }, */}
          {/*                    ]} */}
          {/*                  > */}
          {/*                    <Input placeholder="Enter Example" /> */}
          {/*                  </Form.Item> */}
          {/*                </Col> */}
          {/*                <Col className={"gutter-row " + styles.selectIconCss} span={1}> */}
          {/*                  <i */}
          {/*                    onClick={() => { */}
          {/*                      remove(field.name); */}
          {/*                    }} */}
          {/*                    className={"iconfont iconClose"} */}
          {/*                  /> */}
          {/*                </Col> */}
          {/*              </Row> */}
          {/*            ))} */}
          {/*            {fields.length < 3 && ( */}
          {/*              <Form.Item> */}
          {/*                <div */}
          {/*                  className={styles.add_btn_} */}
          {/*                  onClick={() => { */}
          {/*                    add(); */}
          {/*                  }} */}
          {/*                > */}
          {/*                  + Add */}
          {/*                </div> */}
          {/*              </Form.Item> */}
          {/*            )} */}
          {/*          </div> */}
          {/*        ); */}
          {/*      }} */}
          {/*    </Form.List> */}
          {/*  </div> */}
          {/* </div> */}
          {/* <div> */}
          {/*  <div className={"cusPrimaryLabelCss"}>Response Example</div> */}
          {/*  <div> */}
          {/*    <JSONInput */}
          {/*      id="a_unique_id" */}
          {/*      placeholder={{}} */}
          {/*      locale={locale} */}
          {/*      height="350px" */}
          {/*      width="100%" */}
          {/*      onChange={(value: any) => { */}
          {/*        editResponse(value) */}
          {/*      }} */}
          {/*    /> */}
          {/*  </div> */}
          {/* </div> */}
        </Form>
        <div onClick={HandlerPublish} className={styles.push_btn}>PUBLISH NOW</div>
      </Spin>
      <Modal
        visible={isScanShowing}
        onCancel={cancelScan}
        title="PUBLISH API"
        footer={null}
        width={450}
        destroyOnClose
      >
        <ScanView
          url={Urls.SubmitPublishApi}
          resultUrl={Urls.GetCommonScanResult}
          params={scanParams}
          onSuccess={scanSuccessHandler}
          onFail={scanFailHandler}
          onBack={cancelScan}
        />
      </Modal>
    </div>
  );
};

export default FormLay;
